import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  show: false,
  header: 'Default Header',
  activeModalId: null,
  message: 'Default Message',
  buttons: [
    {
      label: 'Close',
      variant: 'secondary',
      onClickKey: 'close',
    },
  ],
};

const PerinHealthModalSlice = createSlice({
  name: 'perinHealthModal',
  initialState,
  reducers: {
    openModal: (state, action) => {
      const { header, message, buttons, activeModalId } = action.payload;
      return {
        ...state,
        show: true,
        header,
        message,
        buttons,
        activeModalId
      };
    },
    closeModal: (state) => {
      return {
        ...state,
        show: false,
        activeModalId: null
      };
    },
  },
});

export const { openModal, closeModal, setInputValue } = PerinHealthModalSlice.actions;
export default PerinHealthModalSlice.reducer;
